import Link from "next/link";
import { TextFieldElement } from "../widgets/Form/TextFieldElement";
import { Button } from "@mui/material";
import IconLogin from "../icons/IconLogin";
import { useQuery } from "@graphcommerce/graphql";
import { useFormContext } from "@graphcommerce/ecommerce-ui";
import { useState } from "react";
import { useLoading } from "../../context/loadingContext";
import { customer_loginDocument, customer_loginQueryVariables } from "../../graphql/login/loginPassword.gql";
import useLogin from "./useLogin";
import CloseBtn from "./CloseBtn";

export default function LoginForm({ setActiveForm, stayAtPage }: { setActiveForm: (a: string) => void; stayAtPage?: boolean }) {
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [successMessage, setSuccessMessage] = useState<any>(null);
  const { refetch } = useQuery(customer_loginDocument, { skip: true });
  const { setLoading } = useLoading();
  const { handleLogin } = useLogin();
  const methods = useFormContext();
  const handleSubmit = (values: any) => {
    const { mobileNumber, password } = values as customer_loginQueryVariables;
    setLoading(true);
    refetch({
      mobileNumber,
      password
    }).then((res) => {
      if (res?.data?.customer_login && res.data.customer_login.token) {
        handleLogin(res.data.customer_login.token, null, true, stayAtPage);
        setSuccessMessage('ورود با موفقیت انجام شد.')
        setErrorMessage(null);
      }
    }).catch((err) => setErrorMessage(err.message)).finally(() => setLoading(false))
  }
  return (
    <div className="pt-16 md:pt-5">
      {errorMessage && <div className="text-sm text-error-500 font-normal text-center my-4">
        {errorMessage}
      </div>}
      {successMessage && <div className="text-sm text-secondary-300 font-normal text-center my-4">
        {successMessage}
      </div>}
      <p className="text-base font-medium">ورود کاربران</p>
      <form onSubmit={methods.handleSubmit(handleSubmit)}>
        <TextFieldElement
          name="mobileNumber"
          label="ایمیل یا تلفن همراه"
          placeholder="ایمیل یا تلفن همراه"
          required
          dir="rtl"
          fullWidth
          variant='standard'
          classes={{ root: "!mt-5 rtl" }}
          className="!text-sm"
          color='primary' />

        <TextFieldElement
          name="password"
          type="password"
          label="رمز عبور"
          placeholder="رمز عبور"
          required
          dir="rtl"
          fullWidth
          classes={{ root: "!mt-5 rtl" }}
          className="!text-sm"
          variant='standard'
          color='primary' />

        <div className="mt-6 flex w-full items-center justify-between">
          <Link href={'/account/forgot-password'} className="text-sm text-default-100 hover:text-primary-500">
            بازیابی رمز عبور
          </Link>

          <button className="bg-transparent border-none shadow-none outline-0 text-sm text-default-100 hover:text-primary-500" onClick={() => setActiveForm('code')}>ورود با رمز یک‌بارمصرف (پیامکی)</button>
        </div>

        <div className="flex justify-center items-center mt-4">
          <Button type="submit" variant="contained" color="primary" className="flex w-full md:w-auto text-sm justify-center bg-primary-500">
            <IconLogin width={18} height={18} className="ml-1" />
            ورود
          </Button>
        </div>
        <CloseBtn />
      </form>
    </div>
  )
}